import { ApiError } from "@/api/api";
import { Alert, AlertTitle, SxProps } from "@mui/material";
import { ForwardedRef } from "react";

type Props = {
  error: ApiError | null;
  ref?: ForwardedRef<HTMLDivElement>;
  sx?: SxProps;
  onClose?: () => void;
};

export function ApiErrorAlert({ error, sx, onClose, ref }: Props) {
  if (!error) {
    return null;
  }
  return (
    <Alert ref={ref} severity="error" sx={sx} onClose={onClose}>
      <AlertTitle>
        {error.status} {error.statusText}
      </AlertTitle>
      {error.data &&
        (typeof error.data === "string"
          ? error.data
          : error.data.error?.message)}
    </Alert>
  );
}
